<template>
  <div>clear</div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  created(){
      localStorage.removeItem("openId");
  },

  mounted() {},

  methods: {}
}

</script>
<style lang='scss' scoped>
</style>